import { useSelector } from "react-redux";

import { FormGroup, FormControlLabel, Checkbox, Typography } from "@mui/material";

export default function LitcoCheckbox(props) {
  const { name, label, checked, onChange, disabled } = props;

  const globalLoading = useSelector((state) => state.loading.active); //Fields are automatically disabled if API is in use

  return (
    <FormGroup>
      <FormControlLabel
        control={
          <Checkbox
            name={name}
            checked={checked}
            onChange={onChange}
            disabled={disabled || globalLoading}
            inputProps={{ "aria-label": "controlled" }}
            sx={{ padding: 0, marginRight: 1 }}
          />
        }
        label={
          <Typography variant="caption" display="block" fontSize={14} color={(disabled || globalLoading) && "#9e9e9e"}>
            {label}
          </Typography>
        }
      />
    </FormGroup>
  );
}
